import React, { forwardRef, PropsWithChildren } from 'react';
import { Typography } from 'fronton-react';
import { cx } from 'linaria';
import { header } from './styles';

type Props = {
  className?: string;
  dataQA?: string;
} & PropsWithChildren;

export const SectionHeader = forwardRef<HTMLElement, Props>(({ children, className, dataQA }, ref) => (
  <Typography className={cx(header, className)} ref={ref} as="h3" variant="h3" data-qa={dataQA}>
    {children}
  </Typography>
));
